module.exports = __webpack_public_path__ + "images/img-1asTURC.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/reviews-on-offerhubs-en.png
// module id = 2056
// module chunks = 0